<template>
  <div id="memorial-accessibility">
    <h2>{{ $t('pages.memorial.accessibility') }}</h2>
    <b-container>
      <accessibility-map />
      <accessibility-ajax-edit
        :name="name"
        :uri="uri"
        :id="id"
        :additionnal-route="additionnalRoute"
        :fields-filter-list="['latitude', 'longitude']"
        :default-model-values="modelPlace"
        :form-id="`${name}-accessibility`"
      />
    </b-container>
  </div>
</template>

<script>
  import AccessibilityMap from '@/components/AccessibilityMap';
  import AccessibilityAjaxEdit from '@/components/custom/AccessibilityAjaxEdit';

  export default {
    name: 'MemorialAccessibility',
    components: {
      AccessibilityAjaxEdit,
      AccessibilityMap,
    },
    data() {
      return {
        id: this.oauth().user.memorial.id,
        name: 'memorial',
        uri: 'api/memorial',
        additionnalRoute: 'accessibility',
        place: { lat: 10, lng: 10 },
      };
    },
    computed: {
      modelPlace() {
        return { latitude: this.place.lat, longitude: this.place.lng };
      },
    },
    mounted() {
      this.$bus.$on('t-event.map.update-pointer', (data) => {
        this.$set(this, 'place', data);
      });

      this.$bus.$once(`t-event.edit-submit.${this.name}.success`, () => {
        const oauth = this.oauth();
        _.merge(oauth.user.memorial, this.modelPlace);
        this.set({ oauth });
      });
    },
  };
</script>

<style lang="scss" scoped>
  #memorial-accessibility {
    /deep/ .vue-map-container {
      height: 400px !important;
      margin-bottom: 10px;
    }
    /deep/ form {
      .hidden-password {
        .field-input {
          display: none;
        }
      }

      .show-password {
        .field-input {
          display: block;
        }
      }
    }
    .vue-map-container {
      width: 100%;
      height: 50vh;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Memorial/accessibility.vue